<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Permisos puestos</span>
	  		    <v-spacer></v-spacer>

	  		    <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( puestos  , 'PERMISOS_ERP')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

	  		    <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

	  		  </v-card-title>
	  		  <v-card-text>
	  		  	<v-row justify="end">
	  		  		<v-col cols="12" md="8" lg="5">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="puestos"
							    class="elevation-0"
							    :search="search"
							    :page.sync="page"
			            @page-count="pageCount = $event"
							    :mobile-breakpoint="100"
			            hide-default-footer
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.activo_sn="{ item }">
							      <v-chip 
							      	v-if="item.activo_sn == 1"
							      	small
							      	color="green"
							      	dark
							      >Si</v-chip>

							      <v-chip 
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >No</v-chip>
							    </template>
							  

							    <template v-slot:item.actions="{ item }">
							    	<v-btn 
							    		color="primary" 
							    		x-small
							    		@click="editItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		  <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="1000px"
      persistent
      scrollable
    >
      <v-card>
      	<v-card-title class="permisos-dialog-header primary white--text py-4">
      		<div>
      			<div class="text-overline white--text text--lighten-2">Permisos del puesto</div>
      			<div class="text-h6 font-weight-bold">{{ editedItem.puesto || puesto }}</div>
      			<div v-if="editedItem.departamento" class="text-caption white--text text--lighten-1">
      				{{ editedItem.departamento }}
      			</div>
      		</div>
      		<v-spacer></v-spacer>
      		<v-chip small color="white" text-color="primary" class="font-weight-bold">
      			{{ totalSeleccionados }} seleccionados
      		</v-chip>
      	</v-card-title>

      	<v-card-text class="permisos-dialog-body black--text pt-4">
      		<v-text-field
      			v-model="searchPermisos"
      			label="Buscar permiso"
      			prepend-inner-icon="mdi-magnify"
      			dense
      			outlined
      			clearable
      			hide-details
      			class="mb-4"
      		></v-text-field>

      		<v-alert
      			v-if="!menuFiltrado.length"
      			type="info"
      			dense
      			text
      			class="mb-0"
      		>
      			No se encontraron permisos con ese criterio de búsqueda.
      		</v-alert>

      		<v-expansion-panels
      			v-else
      			multiple
      			v-model="panelesAbiertos"
      			flat
      			class="permisos-panels"
      		>
      			<v-expansion-panel
      				v-for="(menu, menuIndex) in menuFiltrado"
      				:key="'menu-' + menu.idmenu + '-' + menuIndex"
      			>
      				<v-expansion-panel-header class="permisos-panel-header">
      					<v-row align="center" no-gutters>
      						<v-col cols="12" sm="7" class="d-flex align-center">
      							<v-icon color="primary" class="mr-2 flex-shrink-0">{{ menu.action }}</v-icon>
      							<span class="font-weight-medium">{{ menu.title }}</span>
      						</v-col>
      						<v-col cols="12" sm="5" class="d-flex align-center justify-sm-end mt-2 mt-sm-0">
      							<v-chip
      								x-small
      								:color="contarSeleccionadosMenu(menu) ? 'primary' : 'grey lighten-2'"
      								:text-color="contarSeleccionadosMenu(menu) ? 'white' : 'grey darken-2'"
      							>
      								{{ contarSeleccionadosMenu(menu) }} / {{ contarTotalMenu(menu) }}
      							</v-chip>
      						</v-col>
      					</v-row>
      				</v-expansion-panel-header>

      				<v-expansion-panel-content class="permisos-panel-content">
      					<v-row v-if="menu.direct.length" class="mb-2">
      						<v-col
      							cols="12"
      							sm="6"
      							md="4"
      							v-for="item in menu.direct"
      							:key="'direct-' + item.idactions"
      							class="py-1"
      						>
      							<div
      								class="permiso-item"
      								:class="{ 'permiso-item--active': item.seleccionado }"
      							>
      								<v-checkbox
      									v-model="item.seleccionado"
      									:label="item.title"
      									:value="item.idactions"
      									hide-details
      									dense
      									class="mt-0 pt-0"
      									@click="guardar( item )"
      								></v-checkbox>
      							</div>
      						</v-col>
      					</v-row>

      					<div
      						v-for="grupo in menu.groups"
      						:key="'grupo-' + grupo.idactions"
      						class="permiso-grupo mb-4"
      					>
      						<div class="permiso-grupo-title">
      							<v-icon small color="primary" class="mr-1">mdi-folder-outline</v-icon>
      							<span class="font-weight-medium">{{ grupo.title }}</span>
      							<v-chip x-small class="ml-2" outlined>
      								{{ contarSeleccionadosGrupo(grupo) }} / {{ grupo.items.length }}
      							</v-chip>
      						</div>
      						<v-row>
      							<v-col
      								cols="12"
      								sm="6"
      								md="4"
      								v-for="item in grupo.items"
      								:key="'sub-' + item.idactions"
      								class="py-1"
      							>
      								<div
      									class="permiso-item"
      									:class="{ 'permiso-item--active': item.seleccionado }"
      								>
      									<v-checkbox
      										v-model="item.seleccionado"
      										:label="item.title"
      										:value="item.idactions"
      										hide-details
      										dense
      										class="mt-0 pt-0"
      										@click="guardar( item )"
      									></v-checkbox>
      								</div>
      							</v-col>
      						</v-row>
      					</div>
      				</v-expansion-panel-content>
      			</v-expansion-panel>
      		</v-expansion-panels>
      	</v-card-text>

			  <v-divider></v-divider>
			  <v-card-actions class="px-4 py-3">
			    <v-btn color="grey darken-1" text @click="dialog = false">Cerrar</v-btn>
			    <v-spacer></v-spacer>
			    <span class="text-caption grey--text">Los cambios se guardan al marcar cada opción</span>
			  </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el ciclo?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

	import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
    },


    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        id_forma_pago:0,
				forma_pago:'',
				comentarios:'',
				fecha_alta:null,
				activo_sn:0,
				fecha_baja:null,
				id_usuario_ultimo_cambio:0,
				fecha_ultimo_cambio:null,
      },

      defaultItem: {
        id_forma_pago:0,
				forma_pago:'',
				comentarios:'',
				fecha_alta:null,
				activo_sn:0,
				fecha_baja:null,
				id_usuario_ultimo_cambio:0,
				fecha_ultimo_cambio:null,
      },

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      formaspago: [],
      headers: [
        { text: 'ID'               , value: 'idpuesto'       },
        { text: 'Departamento'     , value: 'departamento'   },
        { text: 'Puesto'           , value: 'puesto'         },
        { text: 'Actions'          , value: 'actions', sortable: false },
      ],

      menuDesglose: [],
      puestos:[],
      puesto: null,
      searchPermisos: '',
      panelesAbiertos: [],
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar Forma de pago' : 'Editar forma de pago'
      },

      menuFiltrado () {
        const term = ( this.searchPermisos || '' ).trim().toLowerCase()
        return ( this.menuDesglose || [] ).map( menu => {
          const direct = []
          const groups = []
          for ( const item of menu.items || [] ) {
            if ( item.items ) {
              const subItems = item.items.filter( subItem => {
                if ( !term ) return true
                const tituloGrupo = ( item.title || '' ).toLowerCase()
                const tituloItem = ( subItem.title || '' ).toLowerCase()
                return tituloGrupo.includes( term ) || tituloItem.includes( term )
              } )
              if ( subItems.length ) {
                groups.push({ ...item, items: subItems })
              }
            } else if ( !term || ( item.title || '' ).toLowerCase().includes( term ) ) {
              direct.push( item )
            }
          }
          return { ...menu, direct, groups }
        } ).filter( menu => menu.direct.length || menu.groups.length )
      },

      totalSeleccionados () {
        let total = 0
        for ( const menu of this.menuDesglose || [] ) {
          total += this.contarSeleccionadosMenu( menu )
        }
        return total
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      await this.initialize()
      await this.getPuestos()
    },

    methods: {
      initialize () {
      	this.dialog = false
      	this.cargar = true
        this.menuDesglose = []
        return this.$http.get('menu.get').then(response=>{
        	this.menuDesglose = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getPuestos () {
      	this.cargar = true
      	this.puestos= []
    		this.$http.get('puestos.all').then(response=>{
          // Hacemos un ciclo para obtener los datos de los departamentos
          this.puestos = response.data
          this.cargar = false
          // Traer los puestos
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
    	},

      editItem (item) {
      	this.cargar = true
        this.editedIndex = this.puestos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.puesto = item.puesto
        this.searchPermisos = ''
      	this.$http.get('permisos.puestos.get/' + this.editedItem.idpuesto ).then(response=>{
      		
      		const idactions = response.data.idactions

      		for( const i in this.menuDesglose ){
    				for( const j in this.menuDesglose[i].items ){
    					if( this.menuDesglose[i].items[j].items ){
	      				for( const k in this.menuDesglose[i].items[j].items ){

	      					if(  idactions.includes( this.menuDesglose[i].items[j].items[k].idactions ) ){
		      					this.menuDesglose[i].items[j].items[k]['seleccionado'] = this.menuDesglose[i].items[j].items[k].idactions
		      				} else {
		      					this.menuDesglose[i].items[j].items[k]['seleccionado'] = false
		      				}
	      				}
    					}else{
	      				if( idactions.includes(this.menuDesglose[i].items[j].idactions) ){
	      					this.menuDesglose[i].items[j]['seleccionado'] = this.menuDesglose[i].items[j].idactions
	      				} else {
	      					this.menuDesglose[i].items[j]['seleccionado'] = false
	      				}
	      			}
    				}
      		}

        	this.cargar = false
	        this.dialog = true
	        this.$nextTick( () => {
	        	this.panelesAbiertos = this.menuFiltrado.map( ( _, index ) => index )
	        })

        }).catch( error =>{
        	this.validarError( error.response.data.message )
      	}).finally( () => { this.cargar = false })
      },

      deleteItem (item) {
        this.editedIndex = this.puestos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem['id_usuario'] = this.getdatosUsuarioERPERP.iderp
        this.$http.put('formaspago.eliminar/' + this.editedItem.id_forma_pago, this.editedItem).then(response=>{
        	this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.searchPermisos = ''
        this.panelesAbiertos = []
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.puesto = null
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
      	if(this.editedItem.horario == ''){
      		this.validarErrorDirecto('Favor de llenar todos los campos')
      	}
      	// Cargamos al usuario que hizo el cambio
      	this.editedItem['id_usuario'] = this.getdatosUsuarioERPERP.iderp
	      this.cargar = true

        if (this.editedIndex > -1) {
	        // Lo mandapos por el EP
          this.$http.put('formaspago.update/' + this.editedItem.id_forma_pago, this.editedItem).then(response=>{
          	this.validarSuccess( response.data.message )
          	this.initialize()
	        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

        } else {
	        // Lo mandapos por el EP
          this.$http.post('formaspago.add', this.editedItem).then(response=>{
          	this.initialize()
	        	this.cargar = false
	        }).catch( error =>{
          	this.validarError( error.response.data.message )
        	}).finally( () => { this.cargar = false })
        }
        this.close()
      },

      guardar( val ){
      	const payload = {
      		...val,
      		idpuesto: this.editedItem.idpuesto
      	}

      	this.$http.post('permisos.puestos.add', payload).then(response=>{
        	this.cargar = false
        }).catch( error =>{
        	this.validarError( error.response.data.message )
      	}).finally( () => { this.cargar = false })
      },

      estaSeleccionado ( item ) {
        return !!item.seleccionado
      },

      obtenerItemsMenu ( menu ) {
        const items = []
        for ( const item of menu.items || [] ) {
          if ( item.items ) items.push( ...item.items )
          else items.push( item )
        }
        return items
      },

      contarTotalMenu ( menu ) {
        return this.obtenerItemsMenu( menu ).length
      },

      contarSeleccionadosMenu ( menu ) {
        return this.obtenerItemsMenu( menu ).filter( item => this.estaSeleccionado( item ) ).length
      },

      contarSeleccionadosGrupo ( grupo ) {
        return ( grupo.items || [] ).filter( item => this.estaSeleccionado( item ) ).length
      },
    },
  }
</script>

<style scoped>
.permisos-dialog-header {
  position: sticky;
  top: 0;
  z-index: 2;
}

.permisos-dialog-body {
  min-height: 200px;
}

.permisos-panels {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.permisos-panel-header {
  min-height: 52px !important;
}

.permisos-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 12px 16px 16px;
}

.permiso-grupo {
  border-left: 3px solid #e3f2fd;
  padding-left: 12px;
}

.permiso-grupo-title {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  color: #424242;
}

.permiso-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 2px 10px;
  min-height: 44px;
  display: flex;
  align-items: center;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.permiso-item:hover {
  background-color: #fafafa;
}

.permiso-item--active {
  border-color: #1976d2;
  background-color: #e3f2fd;
}

.permiso-item >>> .v-label {
  font-size: 0.875rem;
  line-height: 1.3;
}
</style>
